<template lang="pug">
div
  q-dialog(v-model="show", transition-show="slide-left", transition-hide="slide-right")
    show-component(
      :rowId="rowId",
      :name="name",
      @close-show="closeShow",
      @open-print-act="openPrintAct",
      @open-edit="openEdit",
      @destroy-table-item="destroyTableItem"
    )

  q-dialog(v-model="create", transition-show="slide-left", transition-hide="slide-right")
    form-component.form-component(
      :uiPath="formPath",
      :path="createPath",
      :rowId="rowId",
      method="create",
      type="create",
      @reload-table="() => emit('reload')",
      @close-form="closeCreate"
    )

  q-dialog(v-model="edit", transition-show="slide-left", transition-hide="slide-right")
    form-component.form-component(
      :uiPath="formPath",
      :valuesPath="valuesPath",
      :rowId="rowId",
      method="patch",
      type="edit",
      @reload-table="() => emit('reload')",
      @close-form="closeEdit"
    )

  .print-pages(v-show="false")
    print-act-page(ref="printActRef", :parentData="{ data: completionCertificate }")
</template>

<script setup>
import { ref, computed, nextTick } from "vue";
import showComponent from "../show/show.vue";
import printActPage from "../../show_card_components/print/print_completion_certificate.vue";
import printsCss from "../../../../assets/styles/prints/index";
import formComponent from "../form/form.vue";
import { openTabAndPrintContent } from "@/services/print";

const props = defineProps({
  /** Название текущей страницы. Нужно для вызовова нужного компонента. Пример: "acts" */
  name: { type: String, default: "" },
  /** id текущего ряда для его вызова. Если ряд не выбран приходит null. Пример: 1 */
  rowId: { type: null || Number, default: null },
});

const emit = defineEmits([
  /** Эмит перезагрузки данных страницы без сброса фильтров. Не принимает параметры */
  "reload",
  /** Эмит удаления элемента таблицы. В качестве параметра принимает id элемента. Пример: 1 */
  "destroy-table-item",
]);

const show = ref(false);
const edit = ref(false);
const create = ref(false);
const printActRef = ref(null);
const completionCertificate = ref({});

const rowId = computed(() => props.rowId);
const formPath = computed(() => `/api/v3/ui/${props.name}/form`);
const createPath = computed(() => `/api/v3/${props.name}`);
const valuesPath = computed(() => `/api/v3/${props.name}/${rowId.value}`);

const openShow = async () => {
  // Дожидаемся обновления rowId от родителя перед показом карточки компонента
  await nextTick();

  if (rowId.value) {
    show.value = true;
  }
};

const openEdit = async (id = null) => {
  // Дожидаемся обновления rowId от родителя перед показом карточки компонента
  await nextTick();

  if (id) {
    rowId.value = id;
  }

  if (rowId.value) {
    edit.value = true;
  }
};

const openCreate = () => {
  create.value = true;
};

const openPrintAct = async printData => {
  completionCertificate.value = printData;
  await nextTick();

  openTabAndPrintContent({
    html: printActRef.value.$el.innerHTML,
    css: printsCss.completion_certificate,
    closeModalFunction: undefined,
    popup: true,
  });
};

const destroyTableItem = id => {
  emit("destroy-table-item", id);
  closeShow();
};

const closeShow = () => {
  show.value = false;
};

const closeCreate = () => {
  create.value = false;
};

const closeEdit = () => {
  edit.value = false;
};

defineExpose({ openShow, openEdit, openCreate });
</script>

<style scoped lang="scss">
.form-component {
  min-width: 650px;
  min-height: 100vh;
  position: absolute;
  top: 0;
  right: 0;
  padding: 16px;
  border-radius: 15px 0 0 15px !important;
  background: var(--show-card-background);
}
</style>
